<template>
  <el-col :span="7" class="footModule">
    <!-- 快捷入口 -->
    <div class="quickAccess">
      <div class="title">
        当前启动任务 <span class="rotate">{{ openNum }}</span>
      </div>
      <ul>
        <li
          class="item"
          v-for="(item, index) in dataList"
          :key="index"
          @click="handleRouter(item)"
        >
          <img :src="item.img" class="icon-x" alt="" />
          <div>{{ item.name }}</div>
          <div v-if="item.isOpen" class="start-icon">已开启</div>
        </li>
      </ul>
    </div>
  </el-col>
</template>

<script>
import { openState, openSelfState } from "@/api/care/orderCare";
export default {
  data() {
    return {
      dataList: [],
      openNum: 0,
    };
  },
  computed: {
    venderType() {
       // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    }
  },
  watch: {
    venderType(newval) {
      this.init();
    }
  },
  mounted() {
    // this.getPopState();
    // this.getSelfSupport();
    this.init();
  },
  methods: {
    init() {
      if (this.venderType) {
        this.getSelfSupport()
      } else {
        this.getPopState();
      }
    },

    // 获取pop 版数据
    getPopState() {
      // pop 版
      openState().then((res) => {
        var remindSellerConfigData = res.data.remindSellerConfigData;
        var popCommentConfigData = res.data.popCommentConfigData;
        var refundRemindConfigData = res.data.refundRemindConfigData;
        if (res.code == "1") {
          var dataList = [];
          var obj1 = {
              name: "常规催付",
              img: require("@/assets/images/home/icon_tranf1.png"),
              url: "/orderCare/orderCare/expediting",
              isOpen: remindSellerConfigData["8"],
            },
            obj2 = {
              name: "二次催付",
              img: require("@/assets/images/home/icon_tranf2.png"),
              url: "/orderCare/orderCare/twiceExpediting",
              isOpen: remindSellerConfigData["12"],
            },
            obj3 = {
              name: "付款关怀",
              img: require("@/assets/images/home/icon_tranf3.png"),
              url: "/orderCare/payReminder/payReminder",
              isOpen: remindSellerConfigData["1"],
            },
            obj4 = {
              name: "下单关怀（货到）",
              img: require("@/assets/images/home/icon_tranf4.png"),
              url: "/orderCare/orderCare/goodsOrderCare",
              isOpen: remindSellerConfigData["11"],
            },
            obj5 = {
              name: "自动催评",
              img: require("@/assets/images/home/icon_tranf5.png"),
              url: "/orderCare/comtCare/autoEvaluation",
              isOpen: popCommentConfigData["1"],
            },
            obj6 = {
              name: "迟发提醒",
              img: require("@/assets/images/home/icon_tranf6.png"),
              url: "/orderCare/transreMind/delayMind",
              isOpen: remindSellerConfigData["3"],
            },
            obj7 = {
              name: "好评感谢",
              img: require("@/assets/images/home/icon_tranf7.png"),
              url: "/orderCare/comtCare/thankEvaluation",
              isOpen: popCommentConfigData["2"],
            },
            obj8 = {
              name: "中差评安抚",
              img: require("@/assets/images/home/icon_tranf8.png"),
              url: "/orderCare/comtCare/poorEvaluation",
              isOpen: popCommentConfigData["3"],
            };
          dataList.push(obj1, obj2, obj3, obj4, obj5, obj6, obj7, obj8);
          console.log("dataList:", dataList);
          this.dataList = dataList;

          // var step = 0;
          // dataList.forEach(item => {
          //   if (item.isOpen) {
          //     step ++;
          //   }
          // })
          // this.openNum = step;

          // 下单催付的所有开启状态
          var step = 0;

          // 下单关怀
          if (remindSellerConfigData["6"]) {
            // 取消提醒
            step++;
          }
          if (remindSellerConfigData["11"]) {
            // 下单关怀（货到)
            step++;
          }
          if (remindSellerConfigData["8"]) {
            // 常规催付
            step++;
          }
          if (remindSellerConfigData["12"]) {
            // 二次催付
            step++;
          }
          if (remindSellerConfigData["24"]) {
            // 预售尾款催付
            step++;
          }

          // 订单关怀
          if (remindSellerConfigData["3"]) {
            // 迟发提醒
            step++;
          }
          if (remindSellerConfigData["1"]) {
            // 付款关怀
            step++;
          }
          if (remindSellerConfigData["2"]) {
            // 发货提醒
            step++;
          }
          if (remindSellerConfigData["13"]) {
            // 派件提醒
            step++;
          }
          if (remindSellerConfigData["14"]) {
            // 签收提醒
            step++;
          }
          if (remindSellerConfigData["5"]) {
            // 回款关怀
            step++;
          }

          // 售后关怀
          if (popCommentConfigData["2"]) {
            // 好评感谢
            step++;
          }
          if (popCommentConfigData["1"]) {
            // 自动催评
            step++;
          }
          if (popCommentConfigData["3"]) {
            // 中差评安抚
            step++;
          }
          if (refundRemindConfigData["3"]) {
            // 拒绝退款
            step++;
          }
          if (remindSellerConfigData["7"]) {
            // 退货提醒
            step++;
          }
          if (refundRemindConfigData["1"]) {
            // 申请退款
            step++;
          }
          if (refundRemindConfigData["2"]) {
            // 同意退款
            step++;
          }
          if (refundRemindConfigData["4"]) {
            // 退款成功
            step++;
          }
          this.openNum = step;
        }
      });
    },
    // 获取自营的数据
    getSelfSupport() {
      openSelfState().then((res) => {
        console.log("openSelfState:", res);
         var autoMarketingActivityData = res.data.autoMarketingActivityData;
        var popCommentConfigData = res.data.popCommentConfigData;
        var popCommentWaringData = res.data.popCommentWaringData;
        if (res.code == "1") {
          var dataList = [];
          var obj1 = {
              name: "开卡未购会员转化",
              img: require("@/assets/images/home/pop/pop_1.png"),
              url: "/marketing/auto_marketing_official/conversion_unpurchased_members",
              isOpen: autoMarketingActivityData["5"],
            },
            obj2 = {
              name: "首购有礼",
              img: require("@/assets/images/home/pop/pop_2.png"),
              url: "/marketing/auto_marketing_official/first_purchase_official",
              isOpen: autoMarketingActivityData["1"],
            },
            obj3 = {
              name: "复购营销",
              img: require("@/assets/images/home/pop/pop_3.png"),
              url: "/marketing/auto_marketing_official/reminder_purchase_official",
              isOpen: autoMarketingActivityData["2"],
            },
            obj4 = {
              name: "兴趣客户转化",
              img: require("@/assets/images/home/pop/pop_4.png"),
              url: "/marketing/auto_marketing_official/interest_customer_conversion",
              isOpen: autoMarketingActivityData["4"],
            },
            obj5 = {
              name: "客户流失召回",
              img: require("@/assets/images/home/pop/pop_5.png"),
              url: "/marketing/auto_marketing_official/call_customer_churn",
              isOpen: autoMarketingActivityData["3"],
            },
            obj6 = {
              name: "好评感谢",
              img: require("@/assets/images/home/pop/pop_6.png"),
              url: "/orderCare/comtCare/thankEvaluationOfficial",
              isOpen: popCommentConfigData["2"],
            },
            obj7 = {
              name: "中差评安抚",
              img: require("@/assets/images/home/pop/pop_7.png"),
              url: "/orderCare/comtCare/poorEvaluationOfficial",
              isOpen: popCommentConfigData["3"],
            },
            obj8 = {
              name: "评价预警",
              img: require("@/assets/images/home/pop/pop_8.png"),
              url: "/serviceCenter/shopWarning/commentWarning",
              isOpen: popCommentWaringData["1"],
            };
          dataList.push(obj1, obj2, obj3, obj4, obj5, obj6, obj7, obj8);
          console.log("dataList:", dataList);
          this.dataList = dataList;         
          this.openNum = res.data.openCount;
        }
      });
    },

    handleRouter(item) {
      console.log(111111111);
      // if (item.isOpen) {
      // var url = "/orderCare/orderCare/expediting"
      // var routeUrl = this.$router.resolve({
      //   path: item.url
      // })
      // window.open(routeUrl.href, '_blank');

      // this.bus.$emit("topActive", { index: 2, item: this.$store.state.route[2]});
      this.bus.$emit("topHeader", {
        index: 2,
        item: this.$store.state.route[2],
      });
      this.$router.push({
        path: item.url,
      });
    },

    // }
  },
};
</script>

<style scoped lang="scss">
.rotate {
  color: #fff !important;
  font-size: 10px;
  display: inline-block;
  width: 30px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  vertical-align: middle;
  background-image: url("../../assets/images/home/icon_num.svg");
  background-repeat: no-repeat;
  // background-size: cover;
}
.start-icon {
  color: #fff !important;
  font-size: 10px !important;
  line-height: 16px;
  width: 40px;
  background-image: url("../../assets/images/home/icon_start.svg");
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: calc(50% + 20px);
  transform: translateX(-50%);
}
.footModule {
  .quickAccess {
    display: flex;
    flex-direction: column;
    height: 300px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .title {
      flex-shrink: 0;
      box-sizing: border-box;
      height: 54px;
      line-height: 52px;
      border-bottom: 1px solid #f6f6f6;
      padding-left: 24px;
      font-size: 16px;
      // font-weight: 800;
      color: #252c38;
    }
    ul {
      flex: 1;
      display: flex;
      flex-flow: wrap;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 24px;
      .item {
        box-sizing: border-box;
        padding: 11px 0;
        position: relative;
        width: 25%;
        height: 100px;
        text-align: center;
        border-radius: 4px;
        transition: all 0.1s;
        cursor: pointer;
        position: relative;
        div {
          color: #333;
          margin-top: 10px;
        }
        .icon-x {
          width: 44px;
          height: 44px;
        }
      }
    }
  }
}
</style>